var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdiNewspaperVariantOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_newspaper-variant-outline",
    "data-name": "MDI / newspaper-variant-outline",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fb8b24",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_newspaper-variant-outline",
    "data-name": "Path / newspaper-variant-outline",
    d: "M19.053,4.825V17.6H3.895V4.825H19.053m0-1.825H3.895A1.854,1.854,0,0,0,2,4.825V17.6a1.854,1.854,0,0,0,1.895,1.825H19.053A1.854,1.854,0,0,0,20.947,17.6V4.825A1.854,1.854,0,0,0,19.053,3M17.158,13.947H5.789v1.825H17.158V13.947m-7.579-7.3H5.789v5.474H9.579V6.649m1.895,1.825h5.684V6.649H11.474V8.474M17.158,10.3H11.474v1.825h5.684Z",
    transform: "translate(0.526 0.789)",
    fill: "#fb8b24"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiNewspaperVariantOutline);
export default __webpack_public_path__ + "static/media/MDI - newspaper-variant-outline.7ac540b83d16c728b846ab83bf69fda2.svg";
export { ForwardRef as ReactComponent };